import { serviceV2 } from '@/utils/request'

const prefix = '/ai-chatbot/config'
const publicPrefix = '/ai-chatbot/public/config'
const triggerPrefix = '/ai-chatbot/public/triggers'

export default {
  getAiChatbotConfig () {
    return serviceV2.get(`${prefix}`)
  },
  getPublicAiChatbotConfig (params) {
    return serviceV2.get(`${publicPrefix}`, { params })
  },
  getPublicAiChatbotWelcomeTrigger (params) {
    return serviceV2.get(`${triggerPrefix}/welcome`, { params })
  },
  getPublicAiChatbotWelcomeBackTrigger (params) {
    return serviceV2.get(`${triggerPrefix}/welcome-back`, { params })
  },
  getPublicAiChatbotStay30sTrigger (params) {
    return serviceV2.get(`${triggerPrefix}/stay-30s`, { params })
  },
  updateAiChatbotConfig (data) {
    return serviceV2.put(`${prefix}`, data)
  }
}
